let config = {}

export {config};